import { render } from "./ResultComponent.vue?vue&type=template&id=f6386f7e"
import script from "./ResultComponent.vue?vue&type=script&lang=js"
export * from "./ResultComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__